export const environment = {
  production: true,
  environmentDetails: 'https://d-api.yiayia.io/api/',
  userPool: {
    UserPoolId: 'us-east-1_w5V7YT9fS',
    ClientId: '44obh17u3rodf0nv5uf40bcc74',
    region: 'us-east-1'
  },
  identityPoolId: 'us-east-1:dd0cace8-f42b-4191-b679-76ad3421213b',
  buckets: {
      documents: 'prod.yiayia.documents',
      logos_icons: 'prod.yiayia.documents'
    },
  defaultRegion: 'us-east-1',
  idleTime: 3540,
  timeoutTime: 60,
  ui_debug: false,
  show_user_pemissions: true,
  show_careEvent_details: true,
  timePeriodForResidentOperations: 7,
  highLightCareTimeMins : 60,
  sentryDsn: "https://a5fa7b40e65f436984196bb689b46a22@o1419854.ingest.sentry.io/4504051704135680",
  yiayiaOwnerCompany: "Senior Living, LLC",
  knightEnabled: false,
  taskManagerEnabled: false,
  lazyLoadReportAPIs: false,
  floorMapDebug: false,
  log_api_calls: false,
  enableDeepLinksPreLogin: false
};
